<div *ngIf="!isLoading && total > 0" class="message-bubble">
  {{total}}
  <ng-container *ngIf="text">{{text}}</ng-container>
</div>
